var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23008 21.3645V18.2602C1.65223 17.9264 0.443674 16.5245 0.477245 14.8555V4.34087C0.477245 2.43823 2.02152 0.869385 3.96864 0.869385H21.4256C23.3392 0.869385 24.917 2.40485 24.917 4.34087V14.8889C24.917 16.7915 23.3727 18.3603 21.4256 18.3603H9.44073L5.47934 22.2991C5.21077 22.5662 4.87506 22.6997 4.53935 22.6997C4.20364 22.6997 3.86793 22.5662 3.63293 22.3325C3.39793 22.0655 3.23008 21.7317 3.23008 21.3645Z",
    fill: "#62B90A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.483 8.0183V6.21688C13.4714 6.1239 13.4946 6.03092 13.5644 5.96119C13.6806 5.84497 13.8782 5.84497 14.006 5.96119L17.7716 9.31998C17.8413 9.38971 17.8646 9.47106 17.8646 9.55242C17.8646 9.63377 17.8413 9.72675 17.7716 9.78486L14.0176 13.132C13.9595 13.2018 13.8782 13.2482 13.7852 13.2482C13.7038 13.2482 13.6225 13.2134 13.5644 13.1553C13.4946 13.0855 13.4714 12.9926 13.483 12.8996C13.483 12.8996 13.483 11.2028 13.483 11.0982C11.4608 11.0982 9.57799 10.9703 7.6371 13.6666C7.26519 14.1548 7.55575 7.99506 13.483 8.0183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.87c8697afa275379caaf2f8fe2fbb6e2.svg";
export { ForwardRef as ReactComponent };